import { useEffect, useRef } from 'react';

export const usePromiseResolvers = ({
    isApplicable,
    isReadyToResolve,
    addLoadingPromise
}: {
    isApplicable: boolean;
    isReadyToResolve: boolean;
    addLoadingPromise: (promise: Promise<void>) => void;
}) => {
    const promiseRef = useRef<PromiseWithResolvers<void>>(Promise.withResolvers());

    useEffect(() => {
        if (!isReadyToResolve) {
            return;
        }

        promiseRef.current.resolve?.();
    }, [isReadyToResolve, promiseRef]);

    useEffect(() => {
        if (!isApplicable) {
            return;
        }

        const promiseWithResolvers = promiseRef.current;
        addLoadingPromise?.(promiseWithResolvers.promise);

        return () => {
            if (!isApplicable) {
                return;
            }

            // in case the element is removed from the page completely, automatically resolve the promise
            promiseWithResolvers.resolve();
        };
    }, [addLoadingPromise, promiseRef, isApplicable]);
};
